import React, { FC, useState } from 'react';
import { useNavigate } from 'react-router';
import {
	DropdownButton,
	DropdownMenu,
	DropdownPositioningContainer,
	IconButton,
	IconThreeDots,
} from '@montel/montelpro-shared-components-v2';
import { TMenuItem } from '../../menuTypes';
import { TopMenuSeparator } from '../TopMenuSeparator';

export interface KebabMenuProps {
	menuConfig?: TMenuItem[];
	indexOffset?: number;
	showSeparator?: boolean;
	isActiveItemByIndex: (index: number) => boolean;
}

const KebabMenu: FC<KebabMenuProps> = ({
	menuConfig = [],
	indexOffset = 0,
	showSeparator = true,
	isActiveItemByIndex,
}) => {
	const navigate = useNavigate();
	const [isOpen, setIsOpen] = useState(false);

	if (!menuConfig.length) return null;

	function onMenuItemClick(link: string) {
		navigate(link);
		setIsOpen(false);
	}

	return (
		<>
			{showSeparator && <TopMenuSeparator />}
			<DropdownPositioningContainer>
				<IconButton
					icon={<IconThreeDots />}
					variant="tertiary"
					onClick={() => setIsOpen(true)}
				/>
				{isOpen && (
					<DropdownMenu
						alignToRight
						topPosition="1.5rem"
						closeMenu={() => setIsOpen(false)}
					>
						{menuConfig.map((item, index) => {
							if (item.type !== 'Clickable') return undefined;

							const { text, link, icon } = item;
							const isActive = isActiveItemByIndex(
								indexOffset + index,
							);

							return (
								<DropdownButton
									key={`${link}${index}`}
									onClick={
										!isActive
											? () => onMenuItemClick(link)
											: () => {}
									}
								>
									{icon}
									{text}
								</DropdownButton>
							);
						})}
					</DropdownMenu>
				)}
			</DropdownPositioningContainer>
		</>
	);
};

export default KebabMenu;
